import {ChangeDetectionStrategy,ChangeDetectorRef,Component,OnDestroy,OnInit,ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RdUser } from 'app/core/user/user.types';
import { FuseConfigService } from "../../../../@fuse/services/config";
import { AuthService } from "../../../core/auth/auth.service";

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: false
})
export class UserComponent implements OnInit, OnDestroy
{
    user: RdUser;
    avatar: string;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _fuseConfigService: FuseConfigService,
        private _authService: AuthService
    )
    {
    }

    ngOnInit(): void
    {
        // Subscribe to user changes
        this._authService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: RdUser) => {
                this.user = user;
                this._changeDetectorRef.markForCheck();
            });

        // User first load
        this._authService.getRdUser(false);

        this._authService.userAvatar$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((avatar: string)  => {
                if (!this.avatar || !this.avatar.includes('data:image')) {
                    this.avatar = AuthService.resizeAvatar(avatar, 28);
                    this._changeDetectorRef.markForCheck();
                }
            });

        this._authService.userAvatarBlob$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((avatarBlob: string) => {
                if (avatarBlob) {
                    this.avatar = avatarBlob;
                    this._changeDetectorRef.markForCheck();
                }
            });

        this._authService.firebaseUser$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user) => {
                this._authService.setAvatar(user.providerData.find(provider => provider.providerId === 'google.com')?.photoURL ?? AuthService.getGravatarUrl(user.email));
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }
}
